import { render, staticRenderFns } from "./PwaRoleSelect.vue?vue&type=template&id=df644c96&scoped=true&"
import script from "./PwaRoleSelect.vue?vue&type=script&lang=js&"
export * from "./PwaRoleSelect.vue?vue&type=script&lang=js&"
import style0 from "./PwaRoleSelect.vue?vue&type=style&index=0&id=df644c96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df644c96",
  null
  
)

export default component.exports